import React, { useState, Fragment, useEffect } from 'react';
import { Tooltip } from "reactstrap";
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import categoryBotResponseCodeMapping from '../../../../../../data/categoryBotResponseCodeMapping';

import {
    Row,
    Input,
    InputGroup,
    InputGroupAddon,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';

import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { postAPI_Create_Business, gAPI_Business_By_Id, putAPI_Update_Business, putAPI_Delete_Business, gAPI_QuestionOptionList } from '../../../../../../constants/APIs';
import ImageGallery from '../../gallery/index'
import Select from "react-select";
export function AddNewBusiness({
    id,
    visible,
    toggleModal,
    formLabel,
    propertyId,
    domains,
    LoadData
}) {



    const [selectedOptions, setselectedOptions] = useState([]);
    const [selectedTags, setselectedTags] = useState([]);
    const [tags, setTags] = useState([]);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [galleryVisible, setGalleryVisible] = useState(false);


    const categoriesData = [
        { label: "Activities", value: "Activities", key: 0 },
        // { label: "Mountain - Rangi", value: "Mountain - Rangi", key: 1 },
        // { label: "Land – Whenua", value: "Land – Whenua", key: 2 },
        // { label: "Moana – Sea", value: "Moana – Sea", key: 3 },
        { label: "Accommodation", value: "Accommodation", key: 1 },
        // { label: "Motel & Apartments", value: "Motel & Apartments", key: 5 },
        // { label: "Backpackers & Hostels", value: "Backpackers & Hostels", key: 6 },
        // { label: "Bed & Breakfast", value: "Bed & Breakfast", key: 7 },
        // { label: "Boutique & Lodge", value: "Boutique & Lodge", key: 8 },
        // { label: "NZ Luxury Lodge", value: "NZ Luxury Lodge", key: 9 },
        // { label: "Glamping & Camping", value: "Glamping & Camping", key: 10 },
        { label: "Holiday Homes", value: "Holiday Homes", key: 2 },
        { label: "Food & Drink", value: "Food & Drink", key: 3 },
        // { label: "Restaurants & Bars", value: "Restaurants & Bars", key: 13 },
        // { label: "Cafes", value: "Cafes", key: 14 },
        // { label: "Takeaways", value: "Takeaways", key: 15 },
        { label: "Retail", value: "Retail", key: 4 }
    ];

    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };
    const togglegallery = () => {
        setGalleryVisible(!galleryVisible);
    };
    const selectedImage = (image) => {
        setBusinessData({
            ...buisnessData,
            imageLink: image.src,
        });
    };

    const handleRemoveImage = () => {
        setBusinessData({
            ...buisnessData,
            imageLink: '',
        });
    };

    const [buisnessData, setBusinessData] = useState({
        groupId: getGroupID(),
        propertyId: propertyId,
        title: [
            {
                statement: '',
                languageCode: 'en',
            },
        ],
        name: [
            {
                statement: '',
                languageCode: 'en',
            },
        ],
        shortDescription: [
            {
                statement: '',
                languageCode: 'en',
            },
        ],
        longDescription: [
            {
                statement: '',
                languageCode: 'en',
            },
        ],
        conditions: [
            {
                statement: '',
                languageCode: 'en',
            },
        ],
        status: 'Active',
        type: 'Product',
        detailsButton: 'Redirect',
        buyButton: 'Redirect',
        categories: [],
        tags: [],
        priceRangeStart: 0,
        priceRangeEnd: 0,
        promoPriceRangeStart: 0,
        promoPriceRangeEnd: 0,
        phone: '',
        website: '',
        categories: [],
        email: '',
        address: '',
        features: '',
        googleMap: '',
        facebookLink: '',
        instagramLink: '',
        detailsLink: '',
        bookingLink: '',
        twitterLink: '',
        videoLink: '',
        imageLink: '',
        creator: 'dashboard'

    });

    useEffect(() => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Business_By_Id}/${id}`,
            })
                .then(res => {
                    setBusinessData(res.data)
                    var selectedcategories = [];
                    try {
                        res.data.categories.map(
                            (item) => selectedcategories.push(categoriesData.filter((cat) => cat.value === item)[0])
                        )
                    }
                    finally { }
                    setselectedOptions(selectedcategories);
                    AxiosAPI({
                        method: 'get',
                        url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Products`,
                    })
                        .then(res1 => {

                            var options = [];
                            try {
                                res1.data.map(
                                    (item) => options.push({ label: item.option, value: item.option, key: item.id })
                                )
                            }
                            finally { }
                            setTags(options);

                            var selectedTags = [];

                            try {
                                res.data.tags.map(
                                    (item) => selectedTags.push(options.filter((cat) => cat.value === item)[0])
                                )
                            }
                            finally { }
                            setselectedTags(selectedTags);
                        })
                        .catch(err => console.log('err', err));


                })
                .catch(err => console.log('err', err));
        }
        else {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Products`,
            })
                .then(res => {

                    var options = [];
                    try {
                        res.data.map(
                            (item) => options.push({ label: item.option, value: item.option, key: item.id })
                        )
                    }
                    finally { }
                    setTags(options);
                })
                .catch(err => console.log('err', err));
        }

    }, [id]);

    const handleChangeMulti = selectedOptions => {
        setselectedOptions(selectedOptions);
        const categoriesArr = selectedOptions
            .map(elem => elem.value);

        setBusinessData({
            ...buisnessData,
            categories: categoriesArr
        });
    };

    const handleChangeTags = selectedTags => {
        setselectedTags(selectedTags);
        const tagsArr = selectedTags
            .map(elem => elem.value);

        setBusinessData({
            ...buisnessData,
            tags: tagsArr
        });
    };

    const handleChange = e => {
        setBusinessData({
            ...buisnessData,
            [e.target.name]: e.target.value,
        });
    };

    const handleChangeArr = e => {
        const key = e.target.name;
        const value = e.target.value;
        setBusinessData({
            ...buisnessData,
            [key]: [
                {
                    statement: value,
                    languageCode: 'en',
                },
            ],
        });
    };

    const handleDelete = () => {

        AxiosAPI({
            method: 'put',
            url: `${putAPI_Delete_Business}/${id}`,
            data: {
                deleter: 'dashboard'
            },
        })
            .then(res => {
                setTimeout(() => {
                    toggleModal();
                    LoadData();
                }, 1000)
            })
            .catch(err => {
                console.log(err);
            });
    };

    const generateDeleteButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                      </span>
                      This business will be deleted!
                    </ModalHeader>
                                <ModalBody>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete()}
                                        size="xs"
                                    >
                                        Delete
                      </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        Cancel
                      </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={galleryVisible} toggle={togglegallery} style={{ maxWidth: '1000px' }}>
                                <ModalHeader toggle={togglegallery}>
                                    Select Image or Upload New Image
                                </ModalHeader>
                                <ModalBody>
                                    <ImageGallery propertyId={propertyId} selectedImage={selectedImage} togglegallery={togglegallery}
                                        hideUserUploads={false} searchText={""} />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    const handleSubmit = () => {
        if (id !== undefined) {

            const formmatedData = { ...buisnessData, Updater: 'admin' };

            AxiosAPI({
                method: 'put',
                url: `${putAPI_Update_Business}/${id}`,
                data: formmatedData,
            })
                .then(res => {
                    //console.log(res.data);
                    setTimeout(() => {
                        toggleModal();
                        LoadData();
                    }, 1000)
                }

                )
                .catch(err => {
                    console.log('err', err);
                });
        }
        else {
            const formmatedData = { ...buisnessData };
            AxiosAPI({
                method: 'post',
                url: `${postAPI_Create_Business}`,
                data: formmatedData,
            })
                .then(res => {
                    console.log(res.data);
                    setTimeout(() => {
                        toggleModal();
                        LoadData();
                    }, 1000)
                }

                )
                .catch(err => {
                    console.log('err', err);
                });
        }
    };

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggleModal} wrapClassName="modal-right"
                backdrop="static">
                <ModalHeader toggle={toggleModal}>{formLabel}</ModalHeader>
                {buisnessData != undefined && (
                    <ModalBody>
                        {/* <pre>{JSON.stringify(buisnessData, null, 2)}</pre> */}
                        <Label className="mt-3">
                            Title
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChangeArr}
                            value={buisnessData.title != null ? buisnessData.title[0].statement : ''}
                            name="title"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Buisness Name
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChangeArr}
                            value={buisnessData.name != null ? buisnessData.name[0].statement : ''}
                            name="name"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Type
                        </Label>
                        <Input
                            type="select"
                            name="type"
                            value={buisnessData.type}
                            onChange={handleChange}
                        >

                            <option value="Product">Product</option>
                            <option value="Promotion">Promotion</option>

                        </Input>
                        <Label className="mt-3">
                            Details Style (Show you Details button to behave)
                        </Label>
                        <Input
                            type="select"
                            name="detailsButton"
                            value={buisnessData.detailsButton}
                            onChange={handleChange}
                        >

                            <option value="Redirect">Redirect to the business details page</option>
                            <option value="UrlWebView">Open business details page in bot</option>
                            <option value="CustomWebView">Open business details from bot</option>

                        </Input>

                        <Label className="mt-3">
                            Selling Style (How to want Buy button to behave)
                        </Label>
                        <Input
                            type="select"
                            name="buyButton"
                            value={buisnessData.buyButton}
                            onChange={handleChange}
                        >

                            <option value="Redirect">Redirect to the business booking page</option>
                            <option value="UrlWebView">Open business booking page in bot</option>
                            {/* <option value="PrintPromo">Offer a promo code</option> */}
                            <option value="SellVoucher">Sell a voucher</option>

                        </Input>
                        <Label className="mt-3">
                            Short Description
                        </Label>

                        <Input
                            type="textarea"
                            onChange={handleChangeArr}
                            value={buisnessData.shortDescription != null ? buisnessData.shortDescription[0].statement : ''}
                            name="shortDescription"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Long Description
                        </Label>

                        <Input
                            type="textarea"
                            onChange={handleChangeArr}
                            value={buisnessData.longDescription != null ? buisnessData.longDescription[0].statement : ''}
                            name="longDescription"
                            placeholder=""
                        />
                        <Label className="mt-3">
                            Conditions
                        </Label>

                        <Input
                            type="textarea"
                            onChange={handleChangeArr}
                            value={buisnessData.conditions != null ? buisnessData.conditions[0].statement : ''}
                            name="conditions"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Status
                    </Label>
                        <Input
                            type="select"
                            name="status"
                            value={buisnessData.status}
                            onChange={handleChange}
                        >
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                        </Input>

                        <Label className="mt-3">
                            Categories                    </Label>

                        <Select
                            components={{ Input: CustomSelectInput }}
                            className="react-select"
                            classNamePrefix="react-select"
                            isMulti={true}
                            name="form-field-name"
                            value={selectedOptions}
                            onChange={handleChangeMulti}
                            options={categoriesData}
                        />

                        <Label className="mt-3">
                            Tags                    </Label>

                        <Select
                            components={{ Input: CustomSelectInput }}
                            className="react-select"
                            classNamePrefix="react-select"
                            isMulti={true}
                            name="form-field-name"
                            value={selectedTags}
                            onChange={handleChangeTags}
                            options={tags}
                        />
                        <Label className="mt-3">Price Range  </Label>
                        <div className="row">
                            <div className="col-5">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                                    <Input
                                        required
                                        name="priceRangeStart"
                                        type="number"
                                        min="0"
                                        value={buisnessData.priceRangeStart}
                                        onChange={handleChange}
                                    />
                                </InputGroup>

                            </div>
                            <div className="col-2 mt-3">
                                to
                            </div>
                            <div className="col-5">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                                    <Input
                                        required
                                        name="priceRangeEnd"
                                        type="number"
                                        min="0"
                                        value={buisnessData.priceRangeEnd}
                                        onChange={handleChange}
                                    />
                                </InputGroup>
                            </div>
                        </div>
                        <Label className="mt-3">Promotional Price Range  </Label>
                        <div className="row">
                            <div className="col-5">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                                    <Input
                                        required
                                        name="promoPriceRangeStart"
                                        type="number"
                                        min="0"
                                        value={buisnessData.promoPriceRangeStart}
                                        onChange={handleChange}
                                    />
                                </InputGroup>

                            </div>
                            <div className="col-2 mt-3">
                                to
                            </div>
                            <div className="col-5">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                                    <Input
                                        required
                                        name="promoPriceRangeEnd"
                                        type="number"
                                        min="0"
                                        value={buisnessData.promoPriceRangeEnd}
                                        onChange={handleChange}
                                    />
                                </InputGroup>
                            </div>
                        </div>
                        <Label className="mt-3">
                            Phone
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.phone}
                            name="phone"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Website
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.website}
                            name="website"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Email
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.email}
                            name="email"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Address
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.address}
                            name="address"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Features
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.features}
                            name="features"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Google Map
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.googleMap}
                            name="googleMap"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Details Link
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.detailsLink}
                            name="detailsLink"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Booking Link
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.bookingLink}
                            name="bookingLink"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Facebook Link
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.facebookLink}
                            name="facebookLink"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Instagram Link
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.instagramLink}
                            name="instagramLink"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Twitter Link
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.twitterLink}
                            name="twitterLink"
                            placeholder=""
                        />

                        <Label className="mt-3">
                            Video Link
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={buisnessData.videoLink}
                            name="videoLink"
                            placeholder=""
                        />

                        <Label className="mt-3">Image</Label>
                        <div className="text-center">
                            {buisnessData.imageLink != null && buisnessData.imageLink != "" ? (
                                <div className="thumbnail">
                                    <img className="list-thumbnail responsive border-0" src={buisnessData.imageLink} />
                                    <a href="#/" className="remove" data-dz-remove
                                        onClick={() => handleRemoveImage()}
                                    >
                                        {" "}
                                        <i className="glyph-icon simple-icon-trash" />{" "}
                                    </a>
                                </div>
                            ) : ''}

                            <Button color="secondary" className="mt-1" onClick={togglegallery}>
                                Browse Gallery
                    </Button>
                        </div>


                    </ModalBody>)}
                <ModalFooter>
                    <Button color="primary" onClick={handleSubmit}>
                        Save
          </Button>
                    <Button color="secondary" onClick={toggleModal}>
                        Cancel
          </Button>
                    {id && (<Button color="danger" onClick={toggle}>
                        Delete
                    </Button>)}

                </ModalFooter>
            </Modal>
            {generateDeleteButton()}
            {ImageGalleryButton()}
        </Fragment >
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, domains } = settings;
    return {
        propertyId, domains
    };
};

export default injectIntl(connect(mapStateToProps, {})(AddNewBusiness));